(function () {
  'use strict';

  function splitSegs(raw, sep) {
    if (!raw || !String(raw).trim()) return [];
    const s = String(sep || '@@EVTSEP@@');
    return String(raw)
      .split(s)
      .map((t) => t.trim())
      .filter(Boolean);
  }

  function expandFilterList(raw, sep) {
    const out = [];
    for (const chunk of splitSegs(raw, sep)) {
      const seg = chunk.trim();
      if (!seg) continue;
      if (seg.startsWith('[') && seg.endsWith(']')) {
        let parsed = false;
        try {
          const arr = JSON.parse(seg);
          if (Array.isArray(arr)) {
            for (const item of arr) {
              const s = String(item == null ? '' : item).trim();
              if (s) out.push(s);
            }
            parsed = true;
          }
        } catch {
        }
        if (parsed) continue;
        const inner = seg.slice(1, -1).trim();
        for (const part of inner.split(',')) {
          const p = part
            .replace(/^[\s"']+|[\s"']+$/g, '')
            .replace(/^["']|["']$/g, '')
            .trim();
          if (p) out.push(p);
        }
        continue;
      }
      out.push(seg);
    }
    return out;
  }

  function norm(s) {
    return String(s || '')
      .trim()
      .toLowerCase();
  }

  /** Normalize to YYYYMM for month-level filtering (supports legacy YYYYMMDD on cards). */
  function dateMonthKey(raw) {
    const s = String(raw || '').trim();
    if (s.length >= 6) return s.slice(0, 6);
    return s;
  }

  /** Label like "August, 2026" for filter dropdown (value stays YYYYMM). */
  function formatDateKey(key) {
    const ym = dateMonthKey(key);
    if (ym.length !== 6) return key || '';
    const y = Number(ym.slice(0, 4));
    const m = Number(ym.slice(4, 6));
    const dt = new Date(y, m - 1, 1);
    if (Number.isNaN(dt.getTime())) return key;
    const monthStr = dt.toLocaleDateString(undefined, { month: 'long' });
    const yearStr = dt.toLocaleDateString(undefined, { year: 'numeric' });
    return `${monthStr}, ${yearStr}`;
  }

  function collectSources(inner) {
    const grid = inner.querySelector('[data-events-grid]');
    const cards = grid ? [...grid.querySelectorAll('[data-event-card]')] : [];
    const seed = inner.querySelector('[data-event-filter-seed]');
    const out = [];
    if (seed) out.push(seed);
    out.push(...cards);
    return out;
  }

  function uniqSorted(values, caseInsensitive) {
    const map = new Map();
    for (const v of values) {
      const raw = String(v).trim();
      if (!raw) continue;
      const k = caseInsensitive ? raw.toLowerCase() : raw;
      if (!map.has(k)) map.set(k, raw);
    }
    return [...map.values()].sort((a, b) =>
      a.localeCompare(b, undefined, { sensitivity: 'base' })
    );
  }

  function buildOptionButtons(panel, values, formatLabel) {
    panel.querySelectorAll('.events-filter__opt:not([data-value=""])').forEach((b) => b.remove());
    for (const val of values) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'events-filter__opt';
      btn.setAttribute('role', 'option');
      btn.setAttribute('data-value', val);
      btn.setAttribute('aria-selected', 'false');
      btn.textContent = formatLabel ? formatLabel(val) : val;
      panel.appendChild(btn);
    }
  }

  function setActiveOption(dropdown, value) {
    const panel = dropdown.querySelector('.events-filter__panel');
    if (!panel) return;
    const v = value == null ? '' : String(value);
    panel.querySelectorAll('.events-filter__opt').forEach((btn) => {
      const dv = btn.getAttribute('data-value');
      const sel = (dv == null ? '' : dv) === v;
      btn.classList.toggle('is-active', sel);
      btn.setAttribute('aria-selected', sel ? 'true' : 'false');
    });
    const summaryText = dropdown.querySelector('.events-filter__summary-text');
    if (!summaryText) return;
    const active = panel.querySelector('.events-filter__opt.is-active');
    const defLabel = summaryText.dataset.defaultLabel || summaryText.textContent;
    if (!summaryText.dataset.defaultLabel) summaryText.dataset.defaultLabel = defLabel;
    if (!v) {
      summaryText.textContent = defLabel;
    } else if (active) {
      summaryText.textContent = active.textContent.trim();
    }
  }

  function closeOtherDropdowns(current) {
    document.querySelectorAll('.events-filter__dropdown[open]').forEach((d) => {
      if (d !== current) d.removeAttribute('open');
    });
  }

  let outsidePointerCloseBound = false;

  function bindCloseDropdownsOnOutsidePointer() {
    if (outsidePointerCloseBound) return;
    outsidePointerCloseBound = true;
    document.addEventListener(
      'pointerdown',
      function (e) {
        const t = e.target;
        if (!t || typeof t.closest !== 'function') return;
        if (t.closest('.events-filter__dropdown')) return;
        document.querySelectorAll('.events-filter__dropdown[open]').forEach((d) => {
          d.removeAttribute('open');
        });
      },
      true
    );
  }

  function cardMatches(card, state, sep) {
    const city = norm(card.getAttribute('data-filter-city'));
    const date = dateMonthKey(card.getAttribute('data-filter-date'));
    const types = expandFilterList(card.getAttribute('data-filter-types'), sep).map(norm);
    const paces = expandFilterList(card.getAttribute('data-filter-paces'), sep).map(norm);
    const price = norm(card.getAttribute('data-filter-price')) || 'paid';

    if (state.city && city !== norm(state.city)) return false;
    if (state.date && date !== state.date) return false;
    if (state.type) {
      const t = norm(state.type);
      if (!types.includes(t)) return false;
    }
    if (state.pace) {
      const p = norm(state.pace);
      if (!paces.includes(p)) return false;
    }
    if (state.price) {
      if (state.price === 'free' && price !== 'free') return false;
      if (state.price === 'paid' && price === 'free') return false;
    }
    return true;
  }

  function featuredHeroHandle(inner) {
    const root = inner.querySelector('[data-featured-root]');
    if (!root || root.hidden) return '';
    const hero = root.querySelector('.event-featured[data-event-handle]');
    return (hero && hero.getAttribute('data-event-handle')) || '';
  }

  function hasVisibleFeatured(inner) {
    const root = inner.querySelector('[data-featured-root]');
    if (!root || root.hidden) return false;
    return !!root.querySelector('.event-featured');
  }

  function applyFilters(inner, state, sep) {
    const grid = inner.querySelector('[data-events-grid]');
    if (!grid) return 0;
    const cards = [...grid.querySelectorAll('[data-event-card]')];
    const heroHandle = featuredHeroHandle(inner);
    let visible = 0;
    for (const card of cards) {
      let ok = cardMatches(card, state, sep);
      if (ok && heroHandle && card.getAttribute('data-event-handle') === heroHandle) ok = false;
      card.hidden = !ok;
      const wrap = card.closest('[role="listitem"]');
      if (wrap) wrap.toggleAttribute('hidden', !ok);
      if (ok) visible += 1;
    }
    return visible;
  }

  function syncEmptyMessage(inner, visibleGridCount) {
    const emptyEl = inner.querySelector('[data-filter-empty]');
    if (!emptyEl) return;
    const grid = inner.querySelector('[data-events-grid]');
    const cardCount = grid ? grid.querySelectorAll('[data-event-card]').length : 0;
    const featured = hasVisibleFeatured(inner);
    const show = !featured && visibleGridCount === 0 && cardCount > 0;
    emptyEl.hidden = !show;
  }

  function parseHandleOrder(inner) {
    const el = inner.querySelector('script[type="application/json"][data-events-order]');
    if (!el) return [];
    try {
      const raw = JSON.parse(el.textContent.trim());
      if (!Array.isArray(raw)) return [];
      return raw.map((h) => String(h || '').trim()).filter(Boolean);
    } catch {
      return [];
    }
  }

  function featuredTemplatesByHandle(inner) {
    const map = new Map();
    inner.querySelectorAll('template.event-featured-template[data-featured-candidate]').forEach((tpl) => {
      const h = tpl.getAttribute('data-event-handle');
      if (h) map.set(h, tpl);
    });
    return map;
  }

  /** First event in sort order that matches filters becomes the featured hero. */
  function updateFeatured(inner, state, sep) {
    const root = inner.querySelector('[data-featured-root]');
    if (!root) return;
    const order = parseHandleOrder(inner);
    const byHandle = featuredTemplatesByHandle(inner);
    if (order.length === 0 || byHandle.size === 0) return;

    let matched = null;
    for (const handle of order) {
      const tpl = byHandle.get(handle);
      if (tpl && cardMatches(tpl, state, sep)) {
        matched = tpl;
        break;
      }
    }

    if (!matched) {
      root.hidden = true;
      root.replaceChildren();
      return;
    }

    root.hidden = false;
    const frag = matched.content.cloneNode(true);
    root.replaceChildren(...frag.children);
    document.dispatchEvent(
      new CustomEvent('uprunning:events-featured-replaced', {
        bubbles: true,
        detail: { root: root },
      })
    );
  }

  function runFilters(inner, state, sep) {
    updateFeatured(inner, state, sep);
    const visible = applyFilters(inner, state, sep);
    syncEmptyMessage(inner, visible);
  }

  function initToolbar(toolbar) {
    if (toolbar.hasAttribute('data-events-filter-disabled')) return;
    const inner = toolbar.closest('.events-section__inner');
    if (!inner) return;

    const sep =
      inner.querySelector('[data-filter-sep]')?.getAttribute('data-filter-sep') || '@@EVTSEP@@';
    const sources = collectSources(inner);

    const state = { city: '', date: '', type: '', pace: '', price: '' };

    const cities = uniqSorted(
      sources.map((el) => el.getAttribute('data-filter-city')).filter(Boolean),
      true
    );
    const dates = uniqSorted(
      sources.map((el) => dateMonthKey(el.getAttribute('data-filter-date'))).filter(Boolean),
      false
    );
    const types = uniqSorted(
      sources.flatMap((el) => expandFilterList(el.getAttribute('data-filter-types'), sep)),
      true
    );
    const paces = uniqSorted(
      sources.flatMap((el) => expandFilterList(el.getAttribute('data-filter-paces'), sep)),
      true
    );

    const cityDd = toolbar.querySelector('[data-filter="city"]');
    const dateDd = toolbar.querySelector('[data-filter="date"]');
    const typeDd = toolbar.querySelector('[data-filter="type"]');
    const paceDd = toolbar.querySelector('[data-filter="pace"]');

    if (cityDd) buildOptionButtons(cityDd.querySelector('.events-filter__panel'), cities, null);
    if (dateDd)
      buildOptionButtons(dateDd.querySelector('.events-filter__panel'), dates, formatDateKey);
    if (typeDd) buildOptionButtons(typeDd.querySelector('.events-filter__panel'), types, null);
    if (paceDd) buildOptionButtons(paceDd.querySelector('.events-filter__panel'), paces, null);

    toolbar.querySelectorAll('.events-filter__dropdown').forEach((dd) => {
      dd.addEventListener('toggle', () => {
        if (dd.open) closeOtherDropdowns(dd);
      });
      const panel = dd.querySelector('.events-filter__panel');
      if (!panel) return;
      panel.addEventListener('click', (e) => {
        const btn = e.target.closest('.events-filter__opt');
        if (!btn || !panel.contains(btn)) return;
        const key = dd.getAttribute('data-filter');
        const valRaw = btn.getAttribute('data-value');
        const valNorm = valRaw == null ? '' : valRaw;
        if (key === 'city') state.city = valNorm;
        else if (key === 'date') state.date = valNorm;
        else if (key === 'type') state.type = valNorm;
        else if (key === 'pace') state.pace = valNorm;
        else if (key === 'price') state.price = valNorm;
        setActiveOption(dd, valNorm);
        dd.removeAttribute('open');
        runFilters(inner, state, sep);
      });
    });

    runFilters(inner, state, sep);
  }

  function boot() {
    bindCloseDropdownsOnOutsidePointer();
    document.querySelectorAll('[data-events-filter-toolbar]').forEach(initToolbar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
